import {AfterViewInit, Component, ElementRef, isDevMode, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import html2pdf from "html2pdf.js";
import {ActivatedRoute, Router} from "@angular/router";
import {CentreService} from "../../../../services/centre.service";
import {combineLatest, from, Observable, subscribeOn} from "rxjs";
import {map, switchMap, take} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {MatSelectChange} from "@angular/material/select";
import {ChildService} from "../../../../components/child/child.service";
import {FullChild} from "../../../../interfaces/FullChild";
import {Guardian} from "../../../../interfaces/Guardian";
import {getPerformance} from "@angular/fire/performance";
import {UploadFile} from "../../../../interfaces/uploadFile";
import {EducationService} from "../../../education/education.service";
import {Timestamp} from '@angular/fire/firestore';
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";
import {AngularFireStorage} from '@angular/fire/compat/storage';
import {Task} from "../../../task/models/task.model";
import {TasksService} from "../../../task/tasks.service";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {MatDialog} from "@angular/material/dialog";
import {AddReportCardTypeComponent} from "./add-report-card-type/add-report-card-type.component";
import {SubSink} from "../../../../shared/sub-sink";

interface Teacher {
  name: string,
  sign: string,
  designation: string
}

@Component({
  selector: 'app-report-card',
  templateUrl: './report-card.component.html',
  styleUrls: ['./report-card.component.scss']
})
export class ReportCard implements OnInit, AfterViewInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  centreControl = new FormControl()
  studentForm!: FormGroup;
  displayedColumns: string[] = ['position', 'subject', 'sessions', 'topicsCovered', 'grade', 'remarks'];
  mGuardian1Name: string = ''
  mContactDetails: string = ''
  mGuardian2Name: string = ''
  mGuardian1Occupation: string = ''
  imageUrl: string | undefined
  mGuardian2Occupation: string = ''
  dataSource: any;
  mSelectedCentre = ''
  mSelectedCentreName = ''
  @ViewChild('front') front!: ElementRef;
  @ViewChild('back') back!: ElementRef;
  centres$!: Observable<Centre[]>;
  mChildren: FullChild[] = [];
  mId: string | null = null
  mGuardianData: Guardian[] = [];
  selectedChild?: FullChild;
  selectedGrade: any;
  teacherSelected = {
    name: 'Select Teacher',
    sign: '',
    designation: ''
  }
  mLanguageGrade1: any;

  selectedCentre:any;
  displayCentre = (c: any) => c?.centreName;


  childSelectControl = new FormControl(null, Validators.required);
  childSearchControl = new FormControl('');
  filteredChildren: FullChild[] = [];
  childCodeSearchControl = new FormControl('');

  mMathematics: any
  mEvsGkGrade1: any;
  dwaniSign = 'assets/images/teachers/dhwani.png'
  teachers = [
    {
      name: 'Dwani Gujral',
      designation: 'Lead Teacher',
      sign: 'assets/images/teachers/dhwani.png'
    },
    {
      name: 'Ankita Shelar',
      designation: 'Teacher',
      sign: 'assets/images/teachers/ankita-shelar.png'
    },  {
      name: 'Amisha Gupta',
      designation: 'Teacher',
      sign: 'assets/images/teachers/amisha.png'
    },
    {
      name: 'Rajeshree  Kondilkar',
      designation: 'Sr. Teacher',
      sign: 'assets/images/teachers/rajeshree.png'
    },
    {
      name: 'Anshu Chauhan',
      designation: 'Teacher',
      sign: 'assets/images/teachers/anshu-chauhan.png'
    },
    {
      name: 'Priscilla Kutty',
      designation: 'Teacher',
      sign: 'assets/images/teachers/prishna-kutty.png'
    },
    {
      name: 'Jyothi Kamath',
      designation: 'Teacher',
      sign: 'assets/images/teachers/jyothi.png'
    },
    {
      name: 'Muskan Sulthana',
      designation: 'Teacher',
      sign: 'assets/images/teachers/muskan-sultana.png'
    },{
      name: 'Rajina V.B.',
      designation: 'Teacher',
      sign: 'assets/images/teachers/rajina.png'
    },{
      name: 'Reena maurya',
      designation: 'Teacher',
      sign: 'assets/images/teachers/reena.png'
    },
    {
      name: 'Saba Aziz Khan',
      designation: 'Teacher',
      sign: 'assets/images/teachers/ksaba.png'
    },
    {
      name: 'Varsha Parmar',
      designation: 'Teacher',
      sign: 'assets/images/teachers/varsha.png'
    }, {
      name: 'Jennifer Martina',
      designation: 'Teacher',
      sign: 'assets/images/teachers/jenifer.png'
    },
    {
      name: 'Sangeetha R',
      designation: 'Teacher',
      sign: 'assets/images/teachers/sangeetha-signature.png'
    },{
      name: 'Princy Joyce Christopher',
      designation: 'Teacher',
      sign: 'assets/images/teachers/princy.png'
    },
    {
      name: 'Shambhavee Sunil Patekar',
      designation: 'Teacher',
      sign: 'assets/images/teachers/Shambhavee.png'
    },
    {
      name: 'Vinitha M',
      designation: 'Teacher',
      sign: 'assets/images/teachers/Vinitha-signature.png'
    },
    {
      name: 'Sreayshi Bhattacharjee',
      designation: 'Teacher',
      sign: 'assets/images/teachers/Sreayshi Bhattacharjee.jpg'
    },
    {
      name: 'Yamini Singh',
      designation: 'Teacher',
      sign: 'assets/images/teachers/yamini.png'
    },
    {
      name: 'Neha Parab',
      designation: 'Teacher',
      sign: 'assets/images/teachers/neha.png'
    },
    {
      name: 'Kanchan Bala ',
      designation: 'Teacher',
      sign: 'assets/images/teachers/Kanchan.png'
    },
  ]
  dischargeAssessment: any
  childDocuments: UploadFile[] | undefined;
  uploadedPicture: any;
  selectedFiles:any
  totalMathsSession$!: Observable<any>
  totalLanguageSession$!: Observable<any>
  totalEvsSession$!: Observable<any>
  upload: boolean = false
  dischargeSessionDetails: any
  mData: any | undefined
  isView: boolean = false
  isEdit: boolean = false
  protected readonly subscribeOn = subscribeOn;
  LanguageList$!: Observable<any>
  MathTopicList$!: Observable<any>
  EventsList$!: Observable<any>
  EvsGKList$!: Observable<any>
  isPrinting = false;

  // SEARCH + FILTER FOR LANGUAGE
  languageSearchControl = new FormControl('');
  filteredLanguageList: string[] = [];

// SEARCH + FILTER FOR MATHS
  mathSearchControl = new FormControl('');
  filteredMathList: string[] = [];

// SEARCH + FILTER FOR EVS
  evsSearchControl = new FormControl('');
  filteredEvsList: string[] = [];

// SEARCH + FILTER FOR EVENTS
  eventsSearchControl = new FormControl('');
  filteredEventsList: string[] = [];

  teacherSearchControl = new FormControl('');
  filteredTeachers: Teacher[] = [];

//To use for individual and group session counts in formgroup

  private subs = new SubSink();

  constructor(private formBuilder: FormBuilder,
              private zone: NgZone,
              private readonly route: ActivatedRoute,
              private router: Router,
              private readonly mEducationService: EducationService,
              private readonly mCentreService: CentreService,
              private afStorage: AngularFireStorage,
              private readonly snackbar: MatSnackBar,
              private readonly activatedRouter: ActivatedRoute,
              private readonly mChildService: ChildService,
              private angularFireDatabase : AngularFireDatabase,
              private readonly mSnackBar: MatSnackBar,
              private readonly taskService:TasksService,
              private readonly mFirestore: AngularFirestore,
              private mDialog : MatDialog) {
    this.subs.sink = this.route.params.subscribe(res => {
      if (res.id) this.mId = res.id
      this.centres$ = this.mCentreService.getAllCentres()
      this.isEdit = true
    })
    this.isView = this.route.snapshot.data['viewMode'] == true; // Access data using key
    this.LanguageList$ = this.angularFireDatabase.list('types/Report Card Lgn Topic').valueChanges();
    this.MathTopicList$ = this.angularFireDatabase.list('types/Report Card Math Topic').valueChanges();
    this.EventsList$ = this.angularFireDatabase.list('/types/Report Card Events').valueChanges();
    this.EvsGKList$ = this.angularFireDatabase.list('types/Report Card Evs GK Topic').valueChanges();
// alert( this.route.snapshot.data['viewMode'])
  }

  ngOnInit(): void {
    this.studentForm = this.formBuilder.group({
      childCode: ['', Validators.required],
      studentName: ['', Validators.required],
      dateOfBirth: ['', Validators.required],
      fatherName: ['', Validators.required],
      fatherOccupation: ['', Validators.required],
      motherName: ['', Validators.required],
      languageSessions: ['', Validators.required],
      languageTopicsCovered: ['', Validators.required],
      mathSessions: ['', Validators.required],
      mathsTopicsCovered: ['', Validators.required],
      generalRemarks: ['', Validators.required],
      doctorsRecommendation: ['',],
      evsgkSessions: ['', Validators.required],
      evsgkTopicsCovered: ['', Validators.required],
      // languageGrade: ['', Validators.required],
      // mathsGrade: ['', Validators.required],
      // evsgkGrade: ['', Validators.required],
      address: ['', Validators.required],
      contributions: ['Actively participated in all activities', Validators.required],

      grade: ['', Validators.required],
      motherOccupation: ['', Validators.required],
      motherTongue: ['', Validators.required],
      mediumOfInstruction: ['', Validators.required],
      contactDetails: ['', Validators.required],
      email: ['', Validators.email],
      image: [''],
      date: ['', Validators.required],
      admissionDate: ['', Validators.required],
      dischargeDate: ['', Validators.required],
      events: ['', Validators.required],
      mLanguageGrade1: ['', Validators.required],
      mMathematics: ['', Validators.required],
      mEvsGkGrade1: ['', Validators.required],
      teacher: [null, Validators.required],
    })
    if (this.mId != null) {
      this.subs.sink = this.mFirestore.collection(this.env.reportCard).doc(this.mId!!).valueChanges().subscribe((res: any) => {
        console.log(res)
        console.log(res?.image)
        this.mData = res
        this.zone.run(() => {
          this.mCentreService.fetchCentreByCode(res.centreCode).then(c => {
              if (c) {
                this.mSelectedCentre = (c!!.data()!! as Centre).centreCode
                const initialCentre = c.data() as Centre; // Choo}se the initial centre
                this.centreControl.setValue(initialCentre);

              }
            }
          );
        })

        this.selectedChild = res
        this.teacherSelected = res.teacher
        if (!res.image) this.mChildService.getChildByCode(res.childCode).then(c => {
          // alert(JSON.stringify(res.admissionDocuments))
          this.childDocuments = c?.data()?.admissionDocuments
          this.getChildPhotoUrl(this.childDocuments)
        })

        this.studentForm = this.formBuilder.group({
          childCode: [res?.childCode, Validators.required],
          studentName: [res?.studentName, Validators.required],
          fatherName: [res.fatherName, Validators.required],
          fatherOccupation: [res.fatherOccupation, Validators.required],
          motherName: [res.motherName, Validators.required],
          languageSessions: [res.languageSessions, Validators.required],
          languageTopicsCovered: [res.languageTopicsCovered, Validators.required],
          mathSessions: [res.mathSessions, Validators.required],
          mathsTopicsCovered: [res.mathsTopicsCovered, Validators.required],
          evsgkSessions: [res.evsgkSessions, Validators.required],
          evsgkTopicsCovered: [res.evsgkTopicsCovered, Validators.required],
          languageGrade: [res.languageGrade],
          mathsGrade: [res.mathsGrade],
          evsgkGrade: [res.evsgkGrade],
          address: [res.address, Validators.required],
          city: [res.city],
          pincode: [res.pincode],
          image: [res?.image],
          state: [res.state,],
          grade: [res.grade, Validators.required],
          motherOccupation: [res.motherOccupation, Validators.required],
          motherTongue: [res.motherTongue, Validators.required],
          mediumOfInstruction: [res.mediumOfInstruction, Validators.required],
          contactDetails: [res?.contactDetails, Validators.required],
          generalRemarks: [res.generalRemarks, Validators.required],
          email: [res.email],
          date: [res.date.toDate(), Validators.required],
          admissionDate: [res.admissionDate.toDate(), Validators.required],
          dischargeDate: [res.dischargeDate.toDate(), Validators.required],
          events: [res.events, Validators.required],
          contributions: [res.contributions, Validators.required],
          dateOfBirth: [(res.dateOfBirth as unknown as Timestamp).toDate(), Validators.required],
          // REMARKS
          mathsRemarks: [res.mathsRemarks],
          languageRemarks: [res.languageRemarks],
          evsgkRemarks: [res.evsgkRemarks],
          mLanguageGrade1: [res.mLanguageGrade1, Validators.required],
          mMathematics: [res.mMathematics, Validators.required],
          mEvsGkGrade1: [res.mEvsGkGrade1, Validators.required],
          teacher: [res.teacher, Validators.required],
        })


      })

      // Watch for changes in the teacherName field
      // this.studentForm.controls.teacher.valueChanges.subscribe(teacherName => {
      //     const selectedTeacher = this.teachers.find(teacher => teacher.name === teacherName);
      //     if (selectedTeacher) {
      //         this.studentForm.controls.teacher.setValue(selectedTeacher.name);
      //     } else {
      //         // Handle case where teacherName is not found in teacherSelected
      //         // For example, you could clear the selectedTeacher or display an error message
      //     }
      // });
    }

    this.subs.sink = this.childSearchControl.valueChanges.subscribe(text => {
      const value = text?.toLowerCase() || '';

      this.filteredChildren = this.mChildren.filter(c =>
        (`${c.firstName} ${c.lastName}`).toLowerCase().includes(value)
      );
    });

    // LANGUAGE FILTER
    this.subs.sink = this.LanguageList$.subscribe(list => this.filteredLanguageList = list || []);
    this.subs.sink = this.languageSearchControl.valueChanges.subscribe(text => {
      const v = (text || '').toLowerCase();
      this.filteredLanguageList = (this.filteredLanguageList || []).filter(x => x.toLowerCase().includes(v));
    });

// MATHS FILTER
    this.subs.sink = this.MathTopicList$.subscribe(list => this.filteredMathList = list || []);
    this.subs.sink = this.mathSearchControl.valueChanges.subscribe(text => {
      const v = (text || '').toLowerCase();
      this.filteredMathList = (this.filteredMathList || []).filter(x => x.toLowerCase().includes(v));
    });

// EVS FILTER
    this.subs.sink = this.EvsGKList$.subscribe(list => this.filteredEvsList = list || []);
    this.subs.sink = this.evsSearchControl.valueChanges.subscribe(text => {
      const v = (text || '').toLowerCase();
      this.filteredEvsList = (this.filteredEvsList || []).filter(x => x.toLowerCase().includes(v));
    });

// EVENTS FILTER
    this.subs.sink = this.EventsList$.subscribe(list => this.filteredEventsList = list || []);
    this.subs.sink = this.eventsSearchControl.valueChanges.subscribe(text => {
      const v = (text || '').toLowerCase();
      this.filteredEventsList = (this.filteredEventsList || []).filter(x => x.toLowerCase().includes(v));
    });


    // Initialize teacher list for dropdown
    this.filteredTeachers = [...this.teachers];
    this.subs.sink = this.teacherSearchControl.valueChanges.subscribe(text => {
      const value = (text || '').toLowerCase();
      this.filteredTeachers = this.teachers.filter(t =>
        t.name.toLowerCase().includes(value)
      );
    });


  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }


  onChildDropdownOpen() {
    this.filteredChildren = [...this.mChildren];
  }




  // onCentreSelect(selectedCentre: Centre) {
  //   if (!selectedCentre) return;
  //
  //   console.log("Selected Centre:", selectedCentre);
  //
  //   this.selectedCentre = selectedCentre;
  //
  //   // 1️⃣ Set centre details in form
  //   this.studentForm.patchValue({
  //     centreName: selectedCentre.centreName,
  //     centreCode: selectedCentre.centreCode
  //   });
  // }



  onCentreSelect(centre: Centre) {
    if (!centre) return;

    console.log("Selected Centre:", centre);

    this.mSelectedCentre = centre.centreCode;
    this.mSelectedCentreName = centre.centreName;

    this.subs.sink = this.mChildService.getAllotedChildListByCenter(this.mSelectedCentre)
      .subscribe(res => {
        console.log("Children fetched:", res.length);

        this.mChildren = res;
        this.filteredChildren = [...this.mChildren];

        this.childSelectControl.setValue(null);
        this.studentForm.patchValue({
          childCode: '',
          studentName: '',
        });
      });
  }

  onChildSelect($event: MatSelectChange) {
    this.selectChild($event.value as FullChild)
  }

  async onSearchByChildCode() {
    const code = (this.childCodeSearchControl.value || '').trim();
    if (!code) {
      this.mSnackBar.open('Please enter a child code', '', {panelClass: 'error', duration: 3000});
      return;
    }

    const doc = await this.mChildService.getChildByCode(code);
    const child = doc?.data() as FullChild | undefined;

    if (!child) {
      this.mSnackBar.open(`No child found for code "${code}"`, '', {panelClass: 'error', duration: 3000});
      return;
    }

    this.mSelectedCentre = child.centreCode;
    this.mSelectedCentreName = child.centreName;
    this.selectedCentre = {centreCode: child.centreCode, centreName: child.centreName};

    this.subs.sink = this.mChildService.getAllotedChildListByCenter(this.mSelectedCentre)
      .subscribe(res => {
        this.mChildren = res;

        let match = this.mChildren.find(c => c.childCode === child.childCode);
        if (!match) {
          // Not in the fetched centre list (e.g. status filter) — push it so the dropdown can show/select it
          match = child;
          this.mChildren = [child, ...this.mChildren];
        }

        this.filteredChildren = [...this.mChildren];
        this.childSearchControl.setValue('');

        this.childSelectControl.setValue(match as any);
        this.selectChild(match);
      });
  }

  private selectChild(child: FullChild) {
    const fullAddress = [
      child.address || ' ',  // Address line
      child.city || ' ',     // City
      child.state || ' ',   // State
      child.pincode || ' '  // Pincode
    ];  // Filter out empty values and join with ', '
    this.studentForm.reset()

    this.selectedChild = child
    this.childDocuments = child.admissionDocuments
    console.log(this.selectedChild)

    this.studentForm.get('childCode')?.setValue(child.childCode)
    this.studentForm.get('contributions')?.setValue('Actively participated in all activities')
    this.studentForm.get('dischargeDate')?.setValue(null)
    this.studentForm.get('studentName')?.setValue(`${child.firstName} ${child.lastName}`)
    this.studentForm.get('dateOfBirth')?.setValue(child.dob.toDate())
    this.mGuardianData = child.guardians
    this.mContactDetails = child.guardians[0].contactNo
    this.mGuardian1Name = child.guardians[0].firstName + ' ' + child.guardians[0].lastName
    this.mGuardian1Occupation = child.guardians[0].occupation
    this.mGuardian2Name = child.guardians[1].firstName + ' ' + child.guardians[1].lastName
    this.mGuardian2Occupation = child.guardians[1].occupation
    if (child.admissionData[0].dateOfAdmission?.toDate()) this.studentForm.get('admissionDate')?.setValue(child.admissionData[0].dateOfAdmission?.toDate())
    this.studentForm.get('fatherName')?.setValue(this.mGuardian1Name)
    this.studentForm.get('address')?.setValue(fullAddress)
    this.studentForm.get('city')?.setValue(child.city)
    this.studentForm.get('pincode')?.setValue(child.pincode)
    this.studentForm.get('state')?.setValue(child.state)
    this.studentForm.get('fatherOccupation')?.setValue(this.mGuardian1Occupation)
    this.studentForm.get('motherName')?.setValue(this.mGuardian2Name)
    this.studentForm.get('motherOccupation')?.setValue(this.mGuardian2Occupation)
    this.studentForm.get('contactDetails')?.setValue(this.mContactDetails)
    // this.studentForm.get('languageSessions')?.setValue(child)

    this.getChildIndividualEducationSessions(this.selectedChild)
    this.subs.sink = this.mEducationService.getChildIndividualDischargeSession(this.selectedChild.childCode).subscribe(res => {
      console.log('res', res)
      this.dischargeSessionDetails = res
    })

    this.subs.sink = this.mEducationService.getLastDischargeAssessmentByChild(this.selectedChild.childCode).subscribe(res => {
      this.dischargeAssessment = res[res.length - 1]
      if (this.dischargeAssessment) {
        this.setGrade('mEvsGkGrade1', this.dischargeAssessment.evsgkPercentage)
        this.setGrade('mMathematics', this.dischargeAssessment?.mathsPercentage)
        this.setGrade('mLanguageGrade1', this.dischargeAssessment?.languagePercentage)
      } else {
        this.mSnackBar.open('Discharge assessment not found', '', {panelClass: 'error', duration: 3000})
        return
      }
    })

    this.totalMathsSession$ = this.mEducationService.getTotalSessions(this.selectedChild.childCode, 'Math')
    this.totalEvsSession$ = this.mEducationService.getTotalSessions(this.selectedChild.childCode, 'EVS/GK')
    this.totalLanguageSession$ = this.mEducationService.getTotalSessions(this.selectedChild.childCode, 'Language')

    // Combine individual session counts first, THEN add group session counts once — avoids race condition
    this.subs.sink = combineLatest([
      this.totalMathsSession$.pipe(take(1)),
      this.totalEvsSession$.pipe(take(1)),
      this.totalLanguageSession$.pipe(take(1))
    ]).pipe(
      take(1),
      switchMap(([mathSessions, evsSessions, langSessions]) => {
        const indivMath = mathSessions.length;
        const indivEvs  = evsSessions.length;
        const indivLang = langSessions.length;
        return from(this.mEducationService.getGroupSessionSubjectCountsForChild(child.childCode)).pipe(
          map(group => ({
            mathTotal: indivMath + group.maths,
            evsTotal:  indivEvs  + group.evsGk,
            langTotal: indivLang + group.language,
          }))
        );
      })
    ).subscribe(totals => {
      console.log(`📊 Session Totals — Math: ${totals.mathTotal}, EVS: ${totals.evsTotal}, Language: ${totals.langTotal}`);
      this.studentForm.get('mathSessions')?.setValue(totals.mathTotal);
      this.studentForm.get('evsgkSessions')?.setValue(totals.evsTotal);
      this.studentForm.get('languageSessions')?.setValue(totals.langTotal);
    });

    if (child.admissionData[1]?.dateOfDischarge?.toDate() != undefined) {
      this.studentForm.get('dischargeDate')?.setValue(child.admissionData[1].dateOfDischarge?.toDate());
    }

  }



  async onSubmit() {
    const config: MatSnackBarConfig = {
      panelClass: 'success',
      data: { message: 'Uploading image...' },
    };
    if (!this.studentForm.valid) {
      console.log(this.findInvalidControls());
      return;
    }
    this.studentForm.addControl('centreCode', new FormControl(this.mSelectedCentre));
    this.studentForm.addControl('centreName', new FormControl(this.mSelectedCentreName));

    try {
      let docId = this.mId;
      // let formData: any = { ...this.studentForm.value };
      let formData: any = { ...this.studentForm.value };
      delete formData.image;
      const documents: string[] = [];
      if (!docId) {  //* When adding a new report card
        const docRef = await this.mFirestore.collection(this.env.reportCard).add(formData);
        docId = docRef.id;
        if (this.selectedFiles && this.selectedFiles.length > 0 && docId){
          const snackBarRef = this.snackbar.open('Uploading image...', 'Close');
          const newDocuments: string[] = [];
          for (let file of this.selectedFiles) {
            const newPath = `report-card/${docId}/${file.name}`;
            const fileRef = this.afStorage.ref(newPath);
            await fileRef.put(file);
            const downloadURL = await fileRef.getDownloadURL().toPromise();
            newDocuments.push(downloadURL);
          }
          snackBarRef.dismiss();
          formData.image = newDocuments;
          this.studentForm.get('image')?.setValue(newDocuments);
          await this.mFirestore.collection(this.env.reportCard).doc(docId).update({
            image: newDocuments,
          });
          const {assignees,collaborators} = this.taskService.getTaskForAndCollaboratorsEducationTrigger(this.studentForm.value.centreCode, 'Report Card');
          const mEducationTask: Partial<Task> = {
            title: `Conduct Individual  Session for ${this.studentForm.value.studentName}`,
            done: false,
            priority: 'medium',
            assignees: assignees,
            collaborators:collaborators,
            due_date: new Date(),
            note: `Report Card Submitted : ${this.studentForm.value.studentName} of ${this.studentForm.value.centreName}`,
          };

          this.taskService.addAutomatedTask(mEducationTask);


        }
      }



      else {   //* When updating an existing report card
        if (this.selectedFiles && this.selectedFiles.length > 0) {
          const snackBarRef = this.snackbar.open('Uploading image...', 'Close');
          for (let file of this.selectedFiles) {
            const filePath = `report-card/${docId}/${file.name}`;
            const fileRef = this.afStorage.ref(filePath);
            await fileRef.put(file);
            const downloadURL = await fileRef.getDownloadURL().toPromise();
            documents.push(downloadURL);
          }
          snackBarRef.dismiss();
          formData.image = documents;
          this.studentForm.get('image')?.setValue(documents);
          formData.image = this.studentForm.get('image')?.value || this.mData?.image || [];
        }
        await this.mFirestore.collection(this.env.reportCard).doc(docId).update(formData);
      }
      this.navigateUp();
      this.snackbar.open(`Report card ${this.mId ? 'updated' : 'added'} successfully!`, 'Close', { duration: 3000 });

    } catch (error) {
      console.error('Error submitting form:', error);
      this.snackbar.open('Something went wrong while saving the report card.', 'Close', { duration: 3000 });
    }
  }




  onBlur(controlName: string) {
    // Handle onBlur logic here for the specific control
  }

  get mDateOfBirth() {
    return this.studentForm.get('dateOfBirth')?.value
  }

  get mStudentName() {
    return this.studentForm.get('studentName')?.value
  }

  get mAddress() {
    return this.studentForm.get('address')?.value
  }

  get mCity() {
    return this.studentForm.get('city')?.value
  }

  get mState() {
    return this.studentForm.get('state')?.value
  }

  get mPincode() {
    return this.studentForm.get('pincode')?.value
  }

  get mFatherName() {
    return this.studentForm.get('fatherName')?.value
  }

  get mFatherOccupation() {
    return this.studentForm.get('fatherOccupation')?.value
  }

  get mMotherName() {
    return this.studentForm.get('motherName')?.value
  }

  get mGrade() {
    return this.studentForm.get('grade')?.value
  }

  get mMotherOccupation() {
    return this.studentForm.get('motherOccupation')?.value
  }

  get mMotherTounge() {
    return this.studentForm.get('motherTongue')?.value
  }

  get mMediumOfInstruction() {
    return this.studentForm.get('mediumOfInstruction')?.value
  }

  get mPermanantAddress() {
    return this.studentForm.get('permanentAddress')?.value
  }

  get mContactDetails2() {
    return this.studentForm.get('contactDetails')?.value
  }

  get mEmail() {
    return this.studentForm.get('email')?.value
  }

  get mAdmissionDate() {
    return this.studentForm.get('admissionDate')?.value
  }

  get mDischargeDate() {
    return this.studentForm.get('dischargeDate')?.value
  }

  get mDate() {
    return this.studentForm.get('date')?.value
  }

  get generalRemarks() {
    return this.studentForm.get('generalRemarks')?.value
  }

  get mMathsSessions() {
    return this.studentForm.get('mathSessions')?.value
  }

  get mMathsTopicsCovered() {
    return this.studentForm.get('mathsTopicsCovered')?.value
  }

  get mLanguageTopicsCovered() {
    return this.studentForm.get('languageTopicsCovered')?.value
  }

  get mEvsgkTopicsCovered() {
    return this.studentForm.get('evsgkTopicsCovered')?.value
  }

  get mLanguageSessions() {
    return this.studentForm.get('languageSessions')?.value
  }

  get mEVSSessions() {
    return this.studentForm.get('evsgkSessions')?.value
  }

  get mEvsGrade() {
    return this.studentForm.get('evsgkGrade')?.value
  }

  get mMathsGrade() {
    return this.studentForm.get('mathsGrade')?.value
  }

  get mEvsGkGrade() {
    return this.studentForm.get('mEvsGkGrade1')?.value
  }

  get mMathematicsGrade() {
    return this.studentForm.get('mMathematics')?.value
  }

  get mLanguageGrade() {
    return this.studentForm.get('mLanguageGrade1')?.value
  }

  get mEvents() {
    return this.studentForm.get('events')?.value
  }

  get mLanguageRemarks() {
    return this.studentForm.get('languageRemarks')?.value
  }

  get mMathsRemarks() {
    return this.studentForm.get('mathsRemarks')?.value
  }

  get mEvsRemarks() {
    return this.studentForm.get('evsgkRemarks')?.value
  }

  get mContribution() {
    return this.studentForm.get('contributions')?.value
  }

  // Getter functions to simplify accessing form control values
  getFormControlValue(controlName: string): any {
    return this.studentForm.get(controlName)?.value;
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.studentForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  // protected printFront() {
  //   this.isPrinting = true
  //   const content = this.front.nativeElement;
  //
  //   // Configure options for the PDF
  //   const options = {
  //     margin: 10,
  //     filename: `ReportCardFront.pdf`,
  //     image: {type: 'jpeg', quality: 1},
  //     html2canvas: {scale: 1},
  //     jsPDF: {unit: 'mm', format: 'a4', orientation: 'landscape'},
  //
  //   };
  //
  //   // Use html2pdf.js to generate the PDF
  //   html2pdf()
  //     .from(content)
  //     .set(options)
  //     .save();
  //
  // }
  private async convertImageToBase64(url: string): Promise<string> {
    const response = await fetch(url);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);

      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
    });
  }
  protected async printFront() {

    this.isPrinting = true;

    let imageUrl: string | null = null;

    // Handle array or string
    if (Array.isArray(this.mData?.image)) {
      imageUrl = this.mData.image[0];
    } else {
      imageUrl = this.mData?.image;
    }

    // Convert firebase image to base64 (Fix CORS)
    if (imageUrl && !imageUrl.startsWith('data:')) {
      try {
        const base64Image = await this.convertImageToBase64(imageUrl);
        this.mData.image = base64Image;
      } catch (err) {
        console.error("Image conversion error", err);
      }
    }

    const content = this.front.nativeElement;

    const options = {
      margin: 10,
      filename: `ReportCardFront.pdf`,
      image: { type: 'jpeg', quality: 1 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        allowTaint: true
      },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: 'landscape'
      }
    };

    html2pdf().from(content).set(options).save();
  }

  // private printBack() {
  //
  //     const content = this.back.nativeElement;
  //
  //     // Configure options for the PDF
  //     const options = {
  //         margin: 10,
  //         filename: `Back.pdf`,
  //         image: {type: 'jpeg', quality: 1},
  //         html2canvas: {scale: 1},
  //         jsPDF: {unit: 'mm', format: 'a4', orientation: 'landscape'}
  //     };
  //
  //     // Use html2pdf.js to generate the PDF
  //     html2pdf()
  //         .from(content)
  //         .set(options)
  //         .save();
  //
  // }


  navigateUp() {
    this.router.navigate(['/home/reports/report-card-table']); // Navigates up one level
  }

  // onCentreSelected($event: MatSelectChange) {
  //   let centre = $event.value as Centre
  //   // this.centreControl.setValue(centre)
  //   this.mSelectedCentre = centre.centreCode
  //   this.mSelectedCentreName = centre.centreName
  //   this.mChildService.getAllotedChildListByCenter(this.mSelectedCentre)
  //     .subscribe(res => this.mChildren = res)
  //
  // }





  generatePerformance(grade: string): string {
    // Add logic to generate performance based on the selected grade
    // You can update the subjects array or any other logic as needed
    switch (grade) {
      case 'A':
        return 'Excellent';
      case 'B':
        return 'Very Good';
      case 'C':
        return 'Good';
      case 'D':
        return 'Fair';
      default:
        return '';
    }
  }

  ngAfterViewInit(): void {
    // this.printFront()
    // this.printBack()
  }

  protected readonly getPerformance = getPerformance;
  stamp = 'https://firebasestorage.googleapis.com/v0/b/acceife-fbdb5.appspot.com/o/signatures%2FScreenshot_2023-12-30_at_7.02.04_PM-removebg-preview.png?alt=media&token=90ba5e0b-8074-447e-a9b8-73038bff0139';

  getCentreName(myString: string) {
    let index: number = myString.indexOf("AL");

    if (index !== -1) {
      // Insert a space after "AL"
      let modifiedString: string = myString.slice(0, index + 2) + " " + myString.slice(index + 2);
      return modifiedString || ''
    } else return myString
  }

  changeTeacher($event: MatSelectChange) {
    this.teacherSelected = $event.value
    // this.studentForm.get('teacher')?.setValue(this.teacherSelected.name)
  }

  getChildPhotoUrl(admissionDocuments: any[] | undefined) {
    if (this.studentForm.get('image')?.value == ('') || this.studentForm.get('image')?.value == null) {
      const childPhotoDocument = admissionDocuments?.find(doc => doc.description === 'Child Photo');
      // this.mImage =childPhotoDocument ? childPhotoDocument.fileUrl : ''
      // alert(this.mImage +'fsdf')
      this.upload = false
      // alert(JSON.stringify(childPhotoDocument))
      // this.studentForm.get('image')?.setValue(childPhotoDocument?.imageUrl)
      if (childPhotoDocument) this.studentForm.get('image')?.setValue(childPhotoDocument?.fileUrl)
      return childPhotoDocument ? childPhotoDocument.fileUrl : this.studentForm.get('image')?.value;
    } else return this.studentForm.controls.image.value
  }

  get getTeacherSelected() {
    return this.teacherSelected = this.studentForm.get('teacher')?.value
  }
  // onFileChange(event: any): void {
  //   this.selectedFiles = event.target.files
  //   const selectedFiles: FileList = event.target.files;
  //   if (selectedFiles) {
  //     this.upload = true
  //     for (let i = 0; i < selectedFiles.length; i++) {
  //       const file = selectedFiles.item(i);
  //       if (file) {
  //         // Assuming you want to display image previews and use URLs for <img> tags
  //         const reader = new FileReader();
  //         reader.onload = (e: any) => {
  //           this.uploadedPicture = (e.target.result);
  //           // this.mImage =this.uploadedPicture
  //           console.log(this.uploadedPicture)
  //         };
  //         reader.readAsDataURL(file); // Convert file to Data URL for preview
  //
  //
  //       }
  //     }
  //   }
  //   this.uploadedPicture = selectedFiles;
  // }
  onFileChange(event: any): void {

    const selectedFiles: FileList = event.target.files;

    if (selectedFiles && selectedFiles.length > 0) {

      const file = selectedFiles[0];

      this.selectedFiles = [file]; // store file for upload

      this.upload = true;

      const reader = new FileReader();

      reader.onload = (e: any) => {
        this.uploadedPicture = e.target.result; // preview only
      };

      reader.readAsDataURL(file);

      // IMPORTANT: DO NOT store base64 in form
      this.studentForm.get('image')?.setValue(null);
    }
  }


  private getChildIndividualEducationSessions(selectedChild: FullChild) {
    this.subs.sink = this.mEducationService.getIndividualSessionsOfAChild(selectedChild).subscribe(res => {
      // alert(`Total sessions : `+res.length)
      console.log('Total Education Sessions : ' + res[0])
    })
  }

  //* USAGE:  this.setGrade('mMathematics', this.dischargeAssessment?.mathsPercentage)
  private setGrade(field: string, percentage: number) {
    console.log('IN SET GRADE FIELD: ' + field + 'PERCENTAGE: ' + percentage)
    let grade = ''
    if (percentage >= 81 && percentage <= 100) {
      grade = 'A'
    }
    if (percentage >= 61 && percentage <= 80) {
      grade = 'B'
    }
    if (percentage >= 41 && percentage <= 60) {
      grade = 'C'
    }
    if (percentage <= 40) {
      grade = 'D'
    }
    console.log(`${field} ${grade}`)
    this.studentForm.get(field)?.setValue(grade)
    return grade
  }

  displayFn(value: string, option?: any): string {
    if (option) {
      return option.centreName;
    } else {
      return value;
    }
  }

  compareWith(a: Teacher, b: Teacher): boolean {
    return a && b && a.name === b.name;
  }

  onAddLanguageTopic(data: any): void {
    this.mDialog.open(AddReportCardTypeComponent, {
      data: data
    });
  }
}
